<mat-icon>warning</mat-icon>
<div class="numero_piezas">{{ numeroIncidencias }}</div>
<div class="descripcion">En curso</div>
